import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { addBooking } from '../../redux/booking/actionCreators';

const InputBooking = () => {
    // integration of react-redux hooks here
    const bookingCount = useSelector(state => state.length);
    const newBookingId = useSelector(state => state.length === 0 ? 1 : state[state.length - 1]?.id + 1);
    const dispatch = useDispatch();

    // this function is submitting the booking form
    const submitBooking = (e) => {
        e.preventDefault();

        // checking and disabling bookings here
        if (bookingCount + 1 !== 4) {
            const data = {
                id: newBookingId,
                from: e.target.from.value,
                to: e.target.to.value,
                date: e.target.date.value,
                totalGuests: e.target.guests.value,
                ticketClass: e.target.ticketClass.value,
            }

            console.log(data);

            if (data.from === data.to) {
                toast.error('Please select different destinations.');
            } else {
                // storing data to redux store here
                dispatch(addBooking(data));
            }
        } else {
            toast.error('Sorry! You can not add more than 3 bookings.');
        }

        e.target.reset();
    }


    // rendering the booking input form here
    return (
        <div className='mt-[160px] mx-4 md:mt-[160px] relative'>
            <div className='bg-white rounded-md max-w-6xl w-full mx-auto'>
                <form onSubmit={submitBooking} className='first-hero lws-inputform'>

                    <div className='des-from'>
                        <p>Destination From</p>
                        <div className='flex flex-row'>
                            <img src='./img/icons/Frame.svg' alt='' />
                            <select className='outline-none px-2 py-2 w-full' name='from' id='lws-from' required>
                                <option value='' hidden>Please Select</option>
                                <option>Dhaka</option>
                                <option>Sylhet</option>
                                <option>Saidpur</option>
                                <option>Cox's Bazar</option>
                            </select>
                        </div>
                    </div>

                    <div className='des-from'>
                        <p>Destination To</p>
                        <div className='flex flex-row'>
                            <img src='./img/icons/Frame.svg' alt='' />
                            <select className='outline-none px-2 py-2 w-full' name='to' id='lws-to' required>
                                <option value='' hidden>Please Select</option>
                                <option>Dhaka</option>
                                <option>Sylhet</option>
                                <option>Saidpur</option>
                                <option>Cox's Bazar</option>
                            </select>
                        </div>
                    </div>

                    <div className='des-from'>
                        <p>Journey Date</p>
                        <input type='date' className='outline-none px-2 py-2 w-full date' name='date' id='lws-date' min={new Date().toISOString().split('T')[0]} required />
                    </div>

                    <div className='des-from'>
                        <p>Guests</p>
                        <div className='flex flex-row'>
                            <img src='./img/icons/Vector (1).svg' alt='' />
                            <select className='outline-none px-2 py-2 w-full' name='guests' id='lws-guests' required>
                                <option value='' hidden>Please Select</option>
                                <option value='1'>1 Person</option>
                                <option value='2'>2 Persons</option>
                                <option value='3'>3 Persons</option>
                                <option value='4'>4 Persons</option>
                            </select>
                        </div>
                    </div>

                    <div className='des-from !border-r-0'>
                        <p>Class</p>
                        <div className='flex flex-row'>
                            <img src='./img/icons/Vector (3).svg' alt='' />
                            <select className='outline-none px-2 py-2 w-full' name='ticketClass' id='lws-ticketClass' required>
                                <option value='' hidden>Please Select</option>
                                <option>Business</option>
                                <option>Economy</option>
                            </select>
                        </div>
                    </div>

                    <button className='addCity' type='submit' id='lws-addCity'>
                        <svg width='15px' height='15px' fill='none' viewBox='0 0 24 24' strokeWidth='2' stroke='currentColor'>
                            <path strokeLinecap='round' strokeLinejoin='round' d='M12 4.5v15m7.5-7.5h-15' />
                        </svg>
                        <span className='text-sm'>Book</span>
                    </button>
                </form>
            </div>
        </div>
    );
};

export default InputBooking;